import React from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Tagline from "@/components/site/Tagline";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import Projects from "@/components/site/Projects";
import Process from "@/components/site/Process";
import About from "@/components/site/About";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const PROJECTS = [
  {
    id: "p-01",
    title: "Fitness with Raj Sharma",
    client: "Raj Sharma — Fitness Coach",
    tag: "Coaching / Web",
    year: "2025",
    summary:
      "High-conversion coaching website with program packages, transformations and an integrated enquiry funnel.",
    image:
      "https://image.thum.io/get/width/1200/crop/900/https://www.fitnesswithrajsharma.com",
    url: "https://www.fitnesswithrajsharma.com",
    color: "#FFD800",
  },
  {
    id: "p-02",
    title: "Serene Journey",
    client: "Serene Journey — Tours & Travel",
    tag: "Travel / Web",
    year: "2025",
    summary:
      "Tours & travel website with curated itineraries, destination pages and direct booking enquiries.",
    image: "https://image.thum.io/get/width/1200/crop/900/https://serenejourney.in",
    url: "https://serenejourney.in/",
    color: "#00E5FF",
  },
];

export default function Portfolio() {
  return (
    <main data-testid="portfolio-root" className="relative">
      <Nav />
      <Hero />
      <Tagline />
      <Marquee />
      <Services />
      <Projects projects={PROJECTS} />
      <Process />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
